import { InjectionToken, Provider } from '@angular/core';

export function getAjsProvider(provide: InjectionToken<any>): Provider {
  return {
    provide,
    useFactory: (i: any) => i.get(provide['_desc']),
    deps: ['$injector'],
  };
}

export const NG1_Q = new InjectionToken<any>('$q');
export const NG1_TIMEOUT = new InjectionToken<any>('$timeout');
export const NG1_HTTP = new InjectionToken<any>('$http');
export const NG1_TEMPLATE_CACHE = new InjectionToken<any>('$templateCache');
export const NG1_TEMPLATE_REQUEST = new InjectionToken<any>('$templateRequest');
export const NG1_TRACE = new InjectionToken<any>('$trace');
export const NG1_COOKIES = new InjectionToken<any>('$cookies');
export const NG1_UIB_MODAL = new InjectionToken<any>('$uibModal');
export const NG1_WINDOW = new InjectionToken<any>('$window');
export const NG1_SCE = new InjectionToken<any>('$sce');
export const NG1_METRIC = new InjectionToken<any>('metric');
export const NG1_EPTICA = new InjectionToken<any>('epticaDeprecatedService');
export const NG1_CONTACT = new InjectionToken<any>('contactDeprecatedService');
export const NG1_IADVIZE = new InjectionToken<any>('iAdvizeService');
export const NG1_VIDEOCONFERENCE = new InjectionToken<any>('videoconference');
export const NG1_TRANSFER = new InjectionToken<any>('transferDeprecatedService');
export const NG1_CONFERENCE = new InjectionToken<any>('conferenceDeprecatedService');
export const NG1_QUALIFICATION = new InjectionToken<any>('qualificationDeprecatedService');
export const NG1_INTER_CONTACT = new InjectionToken<any>('interContactDeprecatedService');
export const NG1_SKYPE = new InjectionToken<any>('skype');
export const NG1_CIRCUIT = new InjectionToken<any>('circuit');
export const NG1_OSV = new InjectionToken<any>('osv');
export const NG1_BASKET_STORE = new InjectionToken<any>('basketStore');
export const NG1_BASKET_MAIL_SERVICE = new InjectionToken<any>('mailBasketService');
export const NG1_BASKET_VISIO_SERVICE = new InjectionToken<any>('visioBasketService');
export const NG1_SOCIAL_NETWORK_TAB_SERVICE = new InjectionToken<any>('socialNetworkTabService');
export const NG1_SOCIAL_NETWORK_FRAME_SERVICE = new InjectionToken<any>('socialNetworkFrameService');
export const NG1_SMS = new InjectionToken<any>('smsDeprecatedService');
export const NG1_APPOINTMENT = new InjectionToken<any>('appointmentDeprecatedService');
export const NG1_PHONE_UNIT = new InjectionToken<any>('unitOutgoingCallDeprecatedService');
export const NG1_MAIL_UNIT = new InjectionToken<any>('outgoingMailDeprecatedService');
export const NG1_SEARCH = new InjectionToken<any>('search');
export const NG1_CUSTOMER_CARD_SERVICE = new InjectionToken<any>('customerCardsDeprecatedService');
export const NG1_KNOWLEDGE_BASE = new InjectionToken<any>('knowledgeBaseService');
export const NG1_DIRECTORY = new InjectionToken<any>('directory');
export const NG1_SCRIPT_REDIRECTION = new InjectionToken<any>('scriptRedirection');
export const NG1_CHAT_KNOWLEDGE = new InjectionToken<any>('chatKnowledgeService');
export const NG1_AGENT_HISTORY = new InjectionToken<any>('agentHistory');
export const NG1_HELPZONE_SEARCH_DEPRECATED_SERVICE = new InjectionToken<any>('helpzoneSearchDeprecatedService');

export const AJS_PROVIDERS = [
  getAjsProvider(NG1_Q),
  getAjsProvider(NG1_TIMEOUT),
  getAjsProvider(NG1_HTTP),
  getAjsProvider(NG1_TEMPLATE_CACHE),
  getAjsProvider(NG1_TEMPLATE_REQUEST),
  getAjsProvider(NG1_TRACE),
  getAjsProvider(NG1_COOKIES),
  getAjsProvider(NG1_UIB_MODAL),
  getAjsProvider(NG1_WINDOW),
  getAjsProvider(NG1_SCE),
  getAjsProvider(NG1_METRIC),
  getAjsProvider(NG1_EPTICA),
  getAjsProvider(NG1_CONTACT),
  getAjsProvider(NG1_IADVIZE),
  getAjsProvider(NG1_VIDEOCONFERENCE),
  getAjsProvider(NG1_TRANSFER),
  getAjsProvider(NG1_CONFERENCE),
  getAjsProvider(NG1_QUALIFICATION),
  getAjsProvider(NG1_INTER_CONTACT),
  getAjsProvider(NG1_SKYPE),
  getAjsProvider(NG1_CIRCUIT),
  getAjsProvider(NG1_OSV),
  getAjsProvider(NG1_BASKET_STORE),
  getAjsProvider(NG1_BASKET_MAIL_SERVICE),
  getAjsProvider(NG1_BASKET_VISIO_SERVICE),
  getAjsProvider(NG1_SOCIAL_NETWORK_TAB_SERVICE),
  getAjsProvider(NG1_SOCIAL_NETWORK_FRAME_SERVICE),
  getAjsProvider(NG1_SMS),
  getAjsProvider(NG1_APPOINTMENT),
  getAjsProvider(NG1_PHONE_UNIT),
  getAjsProvider(NG1_MAIL_UNIT),
  getAjsProvider(NG1_CUSTOMER_CARD_SERVICE),
  getAjsProvider(NG1_SEARCH),
  getAjsProvider(NG1_KNOWLEDGE_BASE),
  getAjsProvider(NG1_DIRECTORY),
  getAjsProvider(NG1_SCRIPT_REDIRECTION),
  getAjsProvider(NG1_AGENT_HISTORY),
  getAjsProvider(NG1_CHAT_KNOWLEDGE),
  getAjsProvider(NG1_HELPZONE_SEARCH_DEPRECATED_SERVICE),
];
